import React from 'react';
import useSafeState from '../../../../../../../useSafeState' 
import * as api from '../../../../../../../Auth/auth'
import TableComp from '../../../../../../../components/Table/TableComp'


export function FTOTableData() {

  const [value, setValue] = useSafeState({});
  const [data, setData] = React.useState(React.useMemo(() => []));
  const [loading, setLoading] = React.useState(false);
    
    React.useEffect( () => {
      getData()
  }, [])

  async function getData() {
    
    setLoading(true)
    const response = await api.fto();
    const d = handleData(response)
    setData( d )
    setLoading(false)
           // NO MEMORY LEAK
    setValue({ key: 'value' });
    }



    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(    {  'col1': response[i].id,
                                          'col2': response[i].Sample,
                                          'col3': response[i].Uploaded_variation,
                                          'col4': response[i].GENOTYPE,
                                          'col5': response[i].Consequence,
                                          'col6': response[i].SYMBOL,
                                          'col7': response[i].SNPS,
                                          'col8': response[i].CLIN_SIG,
                                          'col9': response[i].DISEASE_TRAIT,
                                          'col10': response[i].PUBMED,
                                          'col11': response[i].FREQUENCY,
                                          'col12': response[i].owner,
            },
                                  );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
          {
              header: 'Sample',
              accessorKey: 'col2',
              cell: info => info.getValue(),
            },
            {
              header: 'Gene',
              accessorKey: 'col6',
              cell: info => info.getValue(),
              },
              {
              header: 'Variation',
              accessorKey: 'col3',
              cell: info => info.getValue(),
              },
              {
              header: 'Genotype',
              accessorKey: 'col4',
              cell: info => info.getValue(),
              },
                {
                 header: 'Type',
                accessorKey: 'col5',
                cell: info => info.getValue(),
                },  
                {
                    header: 'rsID',
                    accessorKey: 'col7',
                    cell: info => info.getValue(),
                  },
                      {
                          header: 'clinvar',
                          accessorKey: 'col8',
                          cell: info => info.getValue(),
                      },
                      {
                        header: 'Trait',
                          accessorKey: 'col9',
                          cell: info => info.getValue(),
                      },
                      {
                        header: 'PubMed',
                          accessorKey: 'col10',
                          cell: info => info.getValue(),
                      }
      ],
      []
      )

return (

<div>
      { loading && <span> Please wait ... fetching data </span>}
      <TableComp columns={columns} data={data} />
</div>
);
}